/* Vogue Bazaar — motion.js
   Scroll reveals, header state, hero slide classes, fly-to-bag, cart drawer,
   countdown, marquee, back-to-top. Loaded with defer after global.js. */
(function () {
  'use strict';
  const T = window.theme || {};
  const S = T.motion || {};
  const html = document.documentElement;
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionOn = S.enabled !== false && !reduced;
  if (!motionOn) html.classList.add('no-motion');
  html.dataset.revealStyle = S.reveal || 'fade-up';
  if (S.kenburns && motionOn) html.classList.add('kenburns');
  if (S.cardZoom) html.classList.add('card-zoom');

  /* ---------- scroll reveal ---------- */
  function tagReveals(root) {
    const scope = root || document;
    const groups = [
      '.tile-grid > .tile', '.product-grid > .card', '.carousel__track > .card', '.stories > .story',
      '.trust > .trust__item', '.collection-list > .tile', '.blog-grid > .article-card'
    ];
    groups.forEach(sel => {
      const parents = new Map();
      $$(sel, scope).forEach(el => {
        if (el.hasAttribute('data-reveal')) return;
        const p = el.parentElement; const i = (parents.get(p) || 0); parents.set(p, i + 1);
        el.setAttribute('data-reveal', ''); el.style.setProperty('--delay', Math.min(i, 11) * 60 + 'ms');
      });
    });
    $$('.section-title, .rich-text, .newsletter, .countdown, .banner, .footer__col', scope).forEach(el => { if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', ''); });
  }
  let io;
  function observe(root) {
    if (!motionOn || html.dataset.revealStyle === 'none' || !('IntersectionObserver' in window)) { $$('[data-reveal]', root).forEach(el => el.classList.add('is-revealed')); return; }
    if (!io) io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal]:not(.is-revealed)', root).forEach(el => io.observe(el));
  }
  tagReveals(); observe();
  // Safety net: anything in or near the viewport that still hasn't revealed after 1.2s gets shown,
  // and everything is revealed when printing or when the tab was hidden during load.
  const revealVisible = () => $$('[data-reveal]:not(.is-revealed)').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight + 100 && r.bottom > -100) el.classList.add('is-revealed'); });
  setTimeout(revealVisible, 1200);
  window.addEventListener('load', () => setTimeout(revealVisible, 300));
  window.addEventListener('beforeprint', () => $$('[data-reveal]').forEach(el => el.classList.add('is-revealed')));
  // re-tag after AJAX content swaps (collection filters, recommendations, cart drawer)
  const mo = new MutationObserver(muts => {
    let touched = false;
    muts.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) touched = true; }));
    if (touched) { tagReveals(); observe(); }
  });
  ['#CollectionResults', '[data-recommendations]', '[data-wishlist-grid]'].forEach(sel => { const el = $(sel); if (el) mo.observe(el, { childList: true, subtree: true }); });

  /* ---------- header scroll state ---------- */
  const header = $('.header');
  if (header) {
    if (S.glass) header.classList.add('header--glass');
    let ticking = false;
    const paint = () => { header.classList.toggle('is-scrolled', window.scrollY > 10); ticking = false; };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(paint); ticking = true; } }, { passive: true });
    paint();
  }

  /* ---------- hero: active slide class (drives Ken Burns + caption stagger) ---------- */
  $$('[data-hero]').forEach(hero => {
    const track = $('.hero__track', hero), slides = $$('.hero__slide', hero);
    const speed = parseInt(hero.dataset.autoplay || '5', 10) || 5;
    hero.style.setProperty('--hero-speed', speed + 's');
    const paint = () => {
      const m = /-?(\d+(?:\.\d+)?)%/.exec(track.style.transform || '');
      const i = m ? Math.round(parseFloat(m[1]) / 100) : 0;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      // restart dot progress
      const dot = $('.hero__dot[aria-current="true"]', hero);
      if (dot) { dot.style.animation = 'none'; void dot.offsetWidth; dot.style.animation = ''; }
    };
    new MutationObserver(paint).observe(track, { attributes: true, attributeFilter: ['style'] });
    paint();
  });

  /* ---------- wishlist heart pop ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
  });

  /* ---------- fly-to-bag + badge bump ---------- */
  function flyToBag(sourceImg) {
    const target = $('[data-cart-count]');
    if (!motionOn || !sourceImg || !target) return;
    const a = sourceImg.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return;
    const img = document.createElement('img');
    img.src = sourceImg.currentSrc || sourceImg.src; img.className = 'fly-img'; img.alt = '';
    img.style.left = a.left + a.width / 2 - 40 + 'px'; img.style.top = a.top + a.height / 2 - 40 + 'px';
    document.body.append(img);
    requestAnimationFrame(() => {
      const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      img.style.transform = `translate(${dx}px, ${dy}px) scale(.15)`; img.style.opacity = '.4';
    });
    setTimeout(() => img.remove(), 950);
  }
  function bump() {
    $$('[data-cart-count]').forEach(el => { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
  }
  document.addEventListener('theme:cart:added', e => {
    flyToBag(e.detail && e.detail.source);
    setTimeout(bump, motionOn ? 850 : 0);
    if (S.cartType === 'drawer') setTimeout(() => drawer.open(true), motionOn ? 700 : 0);
  });

  /* ---------- cart drawer ---------- */
  const drawer = {
    el: $('#CartDrawer'),
    open(refresh) {
      if (!this.el) return;
      if (refresh) this.render();
      this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      const c = $('.cart-drawer__close', this.el); if (c) c.focus();
    },
    close() { if (!this.el) return; this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; },
    async render() {
      if (!this.el) return;
      try {
        const html = await (await fetch(`${T.routes.root}?section_id=cart-drawer`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.cart-drawer__panel');
        const cur = $('.cart-drawer__panel', this.el);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } catch (e) { /* noop */ }
    }
  };
  if (drawer.el) {
    document.addEventListener('click', async e => {
      const o = e.target.closest('[data-cart-open]');
      if (o && S.cartType === 'drawer') { e.preventDefault(); drawer.open(true); return; }
      if (e.target.closest('[data-cart-close]')) { drawer.close(); return; }
      const plus = e.target.closest('[data-cd-plus]'), minus = e.target.closest('[data-cd-minus]'), rm = e.target.closest('[data-cd-remove]');
      const act = plus || minus || rm;
      if (!act) return;
      const line = parseInt(act.dataset.line, 10), qty = parseInt(act.dataset.qty || '0', 10);
      const item = act.closest('.cd-item');
      let next = qty;
      if (plus) next = qty + 1; if (minus) next = Math.max(0, qty - 1); if (rm) next = 0;
      if (next === 0 && item) item.classList.add('is-removing');
      act.disabled = true;
      try {
        await T.cartChange(line, next);
        await drawer.render();
        const c = await (await fetch(T.routes.cart + '.js')).json();
        $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
      } catch (err) { act.disabled = false; if (item) item.classList.remove('is-removing'); if (T.toast) T.toast('Could not update bag'); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') drawer.close(); });
  }

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach(box => {
    const end = new Date(box.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const nums = { d: $('[data-d]', box), h: $('[data-h]', box), m: $('[data-m]', box), s: $('[data-s]', box) };
    const set = (el, v) => { if (!el) return; const t = String(v).padStart(2, '0'); if (el.textContent !== t) { el.textContent = t; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); } };
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      if (diff === 0) { box.classList.add('is-over'); const over = $('[data-over]', box); if (over) over.hidden = false; }
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      set(nums.d, d); set(nums.h, h); set(nums.m, m); set(nums.s, Math.floor(diff / 1000));
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- marquee: duplicate for seamless loop ---------- */
  $$('.marquee__track').forEach(t => { if (motionOn && t.children.length) t.innerHTML += t.innerHTML; });

  /* ---------- back to top ---------- */
  const top = $('.to-top');
  if (top) {
    window.addEventListener('scroll', () => top.classList.toggle('is-visible', window.scrollY > 600), { passive: true });
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: motionOn ? 'smooth' : 'auto' }));
  }

  /* ---------- PDP: success state on add ---------- */
  document.addEventListener('theme:cart:added', () => {
    const btn = $('[data-add-to-bag]'); if (!btn) return;
    const lbl = $('[data-add-label]', btn); const old = btn.dataset.labelAdd;
    btn.classList.add('is-success'); if (lbl) lbl.textContent = '✓ ' + (T.strings.added || 'Added');
    setTimeout(() => { btn.classList.remove('is-success'); if (lbl) lbl.textContent = old; }, 1800);
  });
  document.addEventListener('click', e => {
    if (e.target.closest('.swatch-btn')) { const p = $('[data-product-price]'); if (p) { p.classList.remove('is-flash'); void p.offsetWidth; p.classList.add('is-flash'); } }
  });
})();
